// extracted by mini-css-extract-plugin
export default {"card":"ProductCard_card__N1fyH","container":"PromotedProduct_container__Mn+I6","ad":"PromotedProduct_ad__UjSXD"};